// extracted by mini-css-extract-plugin
export var avatarContainer = "_as-0";
export var avatarTypingWave = "_as-i";
export var gray = "_as-f";
export var green = "_as-c";
export var icon = "_as-9";
export var image = "_as-1";
export var lg = "_as-6";
export var md = "_as-5";
export var presenceDot = "_as-b";
export var red = "_as-d";
export var sm = "_as-4";
export var status = "_as-a";
export var typingDot = "_as-h";
export var typingPill = "_as-g";
export var xl = "_as-7";
export var xs = "_as-3";
export var xxl = "_as-8";
export var xxs = "_as-2";
export var yellow = "_as-e";